"use strict";
import { isRemoteReportingEnabled } from "utils/env";
if (isRemoteReportingEnabled()) {
  window.GIT_COMMIT_HASH = process.env.REACT_APP_GIT_COMMIT_HASH;
}
import * as analyticsNoop from "utils/analytics-noop";
if (typeof window !== "undefined" && window) {
  try {
    window.analytics = analyticsNoop.analyticsCallable;
    window.sendAnalyticsEvent = analyticsNoop.sendAnalyticsEvent;
    window.setUserProperty = analyticsNoop.setUserProperty;
    window.logSwapQuoteFetch = analyticsNoop.logSwapQuoteFetch;
    window.getAnalyticsAtomDirect = analyticsNoop.getAnalyticsAtomDirect;
  } catch (error) {
    console.warn("Analytics no-op setup failed:", error);
  }
}
